<template>
    <div :class="['project-map', FilterMapState()]" :style="`${Render()};`" @click="ProjectRoute()" @keypress.space.prevent="ProjectRoute()" :tabindex="coordinates.yearIndex" v-if="show">

        <!-- Tabs help with navigating overlapping projects -->
        <div class="map-tab" :style="Styles('Map Tab')" v-if="showTab">
            <div class="tab" :style="`background-color: ${BackgroundColor()};`" @mouseenter="TabHover(true)" @mouseleave="TabHover()"></div>
        </div>

        <div class="project-detail" :style="Styles('Project Detail')">
            <Detail
                :show="index === 0"
                :lowZoom="timelineZoom < 16"
                :detail="Detail()"
                :projectSelected="projectSelected"
                :filtered="Filtered()"
                :searching="searching"
            />
        </div>
    </div>
</template>

<script>
import { CONFIG } from "@/assets/JS/Config.js";
import { ASSETS } from "@/assets/JS/Assets.js";
import Detail from "@/components/Timeline/Project/Map/Detail.vue";
import router from "@/router";
import store from "@/store";

export default {
    name: "TimelineProjectMap",
    props: {
        coordinates: Object,
        index: Number,
        project: Object,
        totalDays: Object,
        timelineZoom: Number,
        show: Boolean,
        showTab: Boolean,
        focused: Boolean,
        projectSelected: Boolean,
        searching: Boolean
    },
    components: { Detail },
    data: () => ({
        classes: { oneDay: "" },
        topography: 0
    }),
    methods: {
        Render: function() {
            const { x, y, width, height } = this.coordinates;
            this.classes.oneDay = height === CONFIG.timeline.dayHeight ? "project-one-day" : "";
            const { timelineTotalDays, daySpan } = this.totalDays;
            this.topography = this.focused ? timelineTotalDays + 10 : timelineTotalDays - daySpan;
            return `left: ${x}%; top: ${y}px; width: ${width}%; height: ${height}px;`;
        },
        BackgroundColor: function() {
            let primaryColor = this.project.ProjectPrimaryColor;
            if (primaryColor === "#fff") {
                primaryColor = CONFIG.projects.palette.timelineProjectDefault;
            }
            return primaryColor;
        },
        Detail: function() {
            return {
                project: this.project.Project,
                dateStart: this.project.Start,
                dateEnd: this.project.End
            };
        },
        TabHover: function(over) {
            this.topography = over ? this.totalDays.timelineTotalDays + 10 : 0;
        },
        Styles: function(element) {
            let style = "";
            const topography = `z-index: ${this.topography};`
            switch(element) {
                case "Project Detail":
                    const opacity = this.focused || !this.showTab ? "1" : ".25";
                    const shift = this.focused || this.showTab ? 25 : 0;
                    style = `background-color: ${this.BackgroundColor()};`;
                    style += `opacity: ${opacity};`;
                    style += `left: ${shift}px;`;
                    style += `margin-right: ${shift}px;`;
                    style += topography;
                    break;
                case "Map Tab":
                    style = topography;
                    break;
            };
            return style;
        },
        ProjectRoute: function() {
            const { ProjectID, Project, TimelineProjectMapID } = this.project;
            const project = ASSETS.CleanURL(Project);
            let route = router.getRoutes().filter(r => r.name === "Project")[0];
            route.meta.id = ProjectID;
            route.meta.timelineProjectMapID = TimelineProjectMapID;
            store.state.projectID = ProjectID;
            store.state.timelineProjectMapID = TimelineProjectMapID;
            ASSETS.SetStorage("Portfolio", store.state);
            route = {
                name: route.name,
                params: { name: project },
                meta: route.meta
            };
            this.$router.push(route);
            this.$emit("project", {
                projectID: ProjectID,
                name: Project,
                timelineProjectMapID: TimelineProjectMapID,
                route
            });
        },

        // Handles filtering of project maps based on current search filter
        Filtered: function() {
            const filtered = [];
            if (this.project.search) {
                for (const projectType of this.project.search.types) {
                    const match = this.project.ProjectTypes.filter(p => p.Name === projectType);
                    if (match.length) {
                        filtered.push(match[0]);
                    }
                }
                return filtered;
            }
            return [];
        },
        FilterMapState: function() {
            let state = "";
            if ((this.searching && this.Filtered().length) || !this.searching) {
                state = "";
            } else {
                state = "unfiltered";
            }
            return state;
        }

    },
    emits: [ "project" ]
};
</script>